<template>
  <div v-if="availableServices !== null">
    <v-row>
      <v-col
        v-for="(v, index) in availableServices"
        :key="index"
        class="pa-4"
        style="width: 300px"
      >
        <div class="text-xs-center">
          <img
            :src="image(v.icon_file)"
            style="height: 80px;"
          >
        </div>
        <div class="text-xs-center ma-2 text-grey-darken-1 subheading">
          {{ $t('Service.Brand.' + v.id) }}
        </div>
      </v-col>
    </v-row>
  </div>
  <div
    v-else
    class="pa-3"
  >
    ...
  </div>

  <!--  <v-list v-if="availableServices !== null">-->
  <!--    <v-list-item v-for="(v, index) in availableServices" :key="index">-->
  <!--      <v-list-tile-action style="width: 40px;">-->
  <!--        <img :src="image(v.icon_file)" style="height: 35px;"/>-->
  <!--      </v-list-tile-action>-->
  <!--      <v-list-tile-content class="ml-2">-->
  <!--        <h2>{{$t('Service.Brand.' + v.id)}}</h2>-->
  <!--      </v-list-tile-content>-->
  <!--    </v-list-tile>-->
  <!--    <div v-if="!availableServices[0]" class="my-3 mx-4 grey&#45;&#45;text">-->
  <!--      {{$t('Service.NoServicesAvailableInOrganization')}}-->
  <!--    </div>-->
  <!--  </v-list>-->
  <!--  <v-list v-else class="pa-3">-->
  <!--    ...-->
  <!--  </v-list>-->
</template>

<script>
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'

  export default {
    mixins: [ServiceIconMixin],
    props: {
      readOnly: Boolean,
      userId: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      availableServices: null
    }),
    created () {
      this.get()
    },
    mounted () {},
    methods: {
      get () {
        this.$http.get('available-services/', {
          params: { limit: 1000 }
        }).then((res2) => {
          this.availableServices = this.$filters.removeUnusedServices(res2.data.results)
        })
      }
    }
  }
</script>

<style scoped>

</style>
